const littleStar = {
  '@version': '3.1',
  identification: {
    encoding: {
      software: 'Flat',
      'encoding-date': '2020-06-26'
    },
    source: 'https://flat.io/score/55946d6816a0acba47e4dcc1-twinkle-twinkle-little-star'
  },
  defaults: {
    scaling: {
      millimeters: '7',
      tenths: '40'
    },
    'page-layout': {
      'page-height': '1596.5714285714287',
      'page-width': '1233.7142857142858',
      'page-margins': {
        'left-margin': '72.57142857142857',
        'right-margin': '72.57142857142857',
        'top-margin': '72.57142857142857',
        'bottom-margin': '72.57142857142857'
      }
    },
    'system-layout': {
      'system-distance': '115.2'
    },
    'staff-layout': {
      'staff-distance': '72.57142857142857'
    }
  },
  credit: {
    'credit-type': 'title',
    'credit-words': 'twinkle twinkle little  star'
  },
  'part-list': {
    'score-part': {
      '@id': 'P1',
      'part-name': 'Violin',
      'part-abbreviation': 'Vln.',
      'score-instrument': {
        '@id': 'P1-I1',
        'instrument-name': 'Violin'
      },
      'midi-instrument': {
        '@id': 'P1-I1',
        'midi-channel': '1',
        'midi-program': '41'
      }
    }
  },
  part: {
    '@id': 'P1',
    measure: [
      {
        '@number': '1',
        attributes: {
          divisions: '1',
          key: {
            fifths: '0'
          },
          time: {
            beats: '4',
            'beat-type': '4'
          },
          clef: {
            sign: 'G',
            line: '2'
          },
          'staff-details': {
            'staff-lines': '5'
          }
        },
        sound: [
          {
            '@tempo': '100'
          }
        ],
        direction: {
          '@placement': 'above',
          'direction-type': {
            metronome: {
              'beat-unit': 'quarter',
              'per-minute': '100'
            }
          },
          staff: '1'
        },
        note: [
          {
            pitch: {
              step: 'C',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          },
          {
            pitch: {
              step: 'C',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          },
          {
            pitch: {
              step: 'G',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          },
          {
            pitch: {
              step: 'G',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          }
        ]
      },
      {
        '@number': '2',
        attributes: [],
        note: [
          {
            pitch: {
              step: 'A',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          },
          {
            pitch: {
              step: 'A',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          },
          {
            pitch: {
              step: 'G',
              octave: '4'
            },
            duration: '2',
            voice: '1',
            type: 'half',
            staff: '1'
          }
        ]
      },
      {
        '@number': '3',
        attributes: [],
        note: [
          {
            pitch: {
              step: 'F',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          },
          {
            pitch: {
              step: 'F',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          },
          {
            pitch: {
              step: 'E',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          },
          {
            pitch: {
              step: 'E',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          }
        ]
      },
      {
        '@number': '4',
        attributes: [],
        note: [
          {
            pitch: {
              step: 'D',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          },
          {
            pitch: {
              step: 'D',
              octave: '4'
            },
            duration: '1',
            voice: '1',
            type: 'quarter',
            staff: '1'
          },
          {
            pitch: {
              step: 'C',
              octave: '4'
            },
            duration: '2',
            voice: '1',
            type: 'half',
            staff: '1'
          }
        ],
        barline: {
          '@location': 'right',
          'bar-style': 'light-heavy'
        }
      }
    ]
  }
}

export default littleStar
